<template>
  <div class="flex items-center justify-center min-h-screen bg-[#F5F0E8]">
    <p class="text-ink/70 text-15">Завершаем вход...</p>
  </div>
</template>

<script setup>
import { onMounted } from 'vue'
import { useAuthStore } from '../store/auth.js'
import router from '../router/index.js'

onMounted(async () => {
  const params = new URLSearchParams(window.location.search)
  const code = params.get('code')

  if (!code) {
    if (window.opener) {
      window.opener.postMessage({ type: 'yandex-error' }, window.location.origin)
      window.close()
    } else {
      router.replace('/onboarding')
    }
    return
  }

  const authStore = useAuthStore()
  const redirectUri = `${window.location.origin}/auth/yandex/callback`

  // Guest user: link Yandex credentials to existing guest account
  const storedUser = JSON.parse(localStorage.getItem('zoya-user') || 'null')
  if (storedUser?.is_guest) {
    if (window.opener) {
      // Popup: send code to parent window for guest linking
      window.opener.postMessage({ type: 'yandex-code', code }, window.location.origin)
      window.close()
    } else {
      // Same tab (mobile/PWA redirect): link guest directly
      try {
        await authStore.linkGuestAccount('yandex', { code, redirect_uri: redirectUri })
        router.replace(authStore.user?.onboarding_done ? '/diary' : '/onboarding')
      } catch {
        router.replace('/profile')
      }
    }
    return
  }

  // Non-guest: standard auth flow
  try {
    await authStore.loginWithYandex(code, redirectUri)
  } catch {
    if (window.opener) {
      window.opener.postMessage({ type: 'yandex-error' }, window.location.origin)
      window.close()
    } else {
      router.replace('/onboarding')
    }
    return
  }

  // Уведомляем родительское окно, что сессия сохранена в localStorage
  if (window.opener) {
    window.opener.postMessage({ type: 'yandex-auth-done' }, window.location.origin)
    window.close()
  } else {
    // _saveSession уже перенаправляет на /onboarding если onboarding_done=false
    // Для завершивших онбординг — в дневник
    if (authStore.user?.onboarding_done) {
      router.replace('/diary')
    }
  }
})
</script>
